import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { WeighingTicket } from '../../../entities/weighing/types';

interface WeighingState {
  tickets: Record<string, WeighingTicket>;
  currentTicketId: string | null;
}

const initialState: WeighingState = {
  tickets: {},
  currentTicketId: null,
};

const weighingSlice = createSlice({
  name: 'weighing',
  initialState,
  reducers: {
    addTicket: (state, action: PayloadAction<WeighingTicket>) => {
      state.tickets[action.payload.id] = action.payload;
    },
    updateTicket: (state, action: PayloadAction<WeighingTicket>) => {
      if (action.payload.id in state.tickets) {
        state.tickets[action.payload.id] = action.payload;
      }
    },
    removeTicket: (state, action: PayloadAction<string>) => {
      delete state.tickets[action.payload];
      if (state.currentTicketId === action.payload) {
        state.currentTicketId = null;
      }
    },
    setCurrentTicket: (state, action: PayloadAction<string>) => {
      state.currentTicketId = action.payload;
    },
  },
});

export const { addTicket, updateTicket, removeTicket, setCurrentTicket } = weighingSlice.actions;
export default weighingSlice.reducer;